// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
var Num = (function () {
    function Num(value0) {
        this.value0 = value0;
    };
    Num.create = function (value0) {
        return new Num(value0);
    };
    return Num;
})();
var Str = (function () {
    function Str(value0) {
        this.value0 = value0;
    };
    Str.create = function (value0) {
        return new Str(value0);
    };
    return Str;
})();
var naturalKey = $foreign.naturalKeyImpl(Num.create)(Str.create);
var genericSortChunk = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Num(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new Str(x.value0);
        };
        throw new Error("Failed pattern match at Algorithm.NaturalSort (line 7, column 1 - line 7, column 56): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Num) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Str) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Algorithm.NaturalSort (line 7, column 1 - line 7, column 56): " + [ x.constructor.name ]);
    }
};
var showSortChunk = {
    show: Data_Show_Generic.genericShow(genericSortChunk)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "Num";
        }
    }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "Str";
        }
    })))
};
var eqSortChunk = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Num && y instanceof Num) {
                return x.value0 === y.value0;
            };
            if (x instanceof Str && y instanceof Str) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var ordSortChunk = {
    compare: Data_Ord_Generic.genericCompare(genericSortChunk)(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdArgument(Data_Ord.ordInt)))(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdArgument(Data_Ord.ordString)))),
    Eq0: function () {
        return eqSortChunk;
    }
};
export {
    Num,
    Str,
    naturalKey,
    genericSortChunk,
    eqSortChunk,
    ordSortChunk,
    showSortChunk
};
//# sourceMappingURL=index.js.map
